import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { Select } from 'antd';
import { getAdminUnits } from '../../../services/taxonomies/zonal-restriction';

const UatList = ({ form, fieldName }) => {
  const [uats, setUats] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await getAdminUnits();
        setUats(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error('Error fetching uats:', error);
        setUats([]);
      }
    })();
  }, []);

  const internalValue = useMemo(
    () => form.getFieldValue(fieldName),
    [form, fieldName],
  );

  const handleChange = useCallback(
    (uatId) => {
      form.setFieldsValue({ [fieldName]: uatId });
    },
    [form, fieldName],
  );

  return (
    <Select
      allowClear
      value={internalValue}
      onChange={handleChange}
      showSearch
      optionFilterProp="children"
      style={{ width: '100%' }}
    >
      {uats.map(({ id, name }) => (
        <Select.Option key={id} value={name}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default UatList;
